var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.105 1.31c.367 0 .61 0 .844.056q.312.075.585.242c.205.125.377.298.636.557l6.432 6.432c.486.486.866.865 1.146 1.195.285.336.488.644.6.992a2.86 2.86 0 0 1 0 1.766c-.112.348-.315.656-.6.991-.28.33-.66.71-1.146 1.195l-1.865 1.866c-.486.486-.866.866-1.196 1.146-.335.285-.643.487-.991.6a2.86 2.86 0 0 1-1.766 0c-.348-.113-.656-.315-.991-.6-.33-.28-.71-.66-1.196-1.146L2.165 10.17c-.259-.259-.431-.431-.557-.636a2 2 0 0 1-.242-.585c-.056-.234-.056-.477-.056-.844V4.318c0-.454 0-.816.024-1.108.024-.3.076-.558.197-.795.194-.381.503-.69.884-.885.237-.12.495-.172.795-.196.293-.024.655-.024 1.108-.024zM5.25 6.667a1.417 1.417 0 1 1 2.833 0 1.417 1.417 0 0 1-2.833 0",
  clipRule: "evenodd"
})));
SvgTag.displayName = "SvgTag";
export { SvgTag as ReactComponent };
export default SvgTag;